module.exports = __webpack_public_path__ + "static/media/edit-icon.b008aa37.svg";